// extracted by mini-css-extract-plugin
export default {"table":"index_table_lRAMb","green":"index_green_Fzj8l","black":"index_black_FsWbe"};